// firebase.js
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBVp7_VXqxPR1hNB6Pqv2RyFzvGmi1Jsro",
  authDomain: "allium-manor.firebaseapp.com",
  projectId: "allium-manor",  
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const functions = firebase.functions();

export default firebase;